<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'FormationsMarketingDigital'
});
</script>
<template>
  <ka-container
    code="prog-03-marketing-digital"
    :data="page.$info.prog03MarketingDigital">
    <!-- Page formation -->
    <ka-container code="page-formation">
      <PFormationEntete
        instance-class="p-formation-entete--p36"
        h-1="Formation en marketing digital"
        texte="La formation est réalisée par un<strong> expert en marketing digital</strong> issu d'une entreprise à succès." />
      <!-- Container experts -->
      <ka-container code="container-experts">
        <ka-text code="titre">
          <span v-html="t('prog03MarketingDigital.pageFormation.containerExperts.titre.value', `Nos experts en marketing digital`)" />
        </ka-text>
        <ka-text code="texte">
          <span v-html="t('prog03MarketingDigital.pageFormation.containerExperts.texte.value', `Le marketing digital est un large domaine qui a pour but de faire connaître votre marque, vos services ou vos produits à vos cibles privilégiées. Sur le papier c’est top ! En pratique en revanche, c’est un peu flou et on ne sait pas toujours par où commencer. Pour cette raison, Matchers propose des formations guidées par un expert qui connaît bien votre secteur d’activité ou votre problématique. `)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container">
          <BlocPreviewProfilExpert
            instance-class="bloc-preview-profil-expert--p36"
            :options="{
              href: `https://www.matchers.fr/expert/288`,
              ariaLabel: `bloc preview profil expert`,
              click: page.blocPreviewProfilExpertClick
            }"
            :tags="page.$constants.blocPreviewProfilExpertTags"
            poste="Head of marketing"
            first-name="Jules"
            enttreprise="&#64;Newton Offices"
            image="https://ucarecdn.com/3e267867-e918-4fef-86e4-3baa836b0e72/" />
          <BlocPreviewProfilExpert
            instance-class="element-1--p36"
            :options="{
              href: `https://www.matchers.fr/expert/306`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element1Click
            }"
            :tags="page.$constants.element1Tags"
            poste="Experte en stratégie digitale"
            first-name="Olivia"
            enttreprise="&#64;Yves Rocher"
            image="https://ucarecdn.com/b971f09c-1dd2-44cc-a973-59eb55d34f6b/" />
          <BlocPreviewProfilExpert
            instance-class="element-2--p36"
            :options="{
              href: `https://www.matchers.fr/expert/97`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element2Click
            }"
            :xs="{ hidden: null }"
            :tags="page.$constants.element2Tags"
            poste="Chief marketing officer"
            first-name="Loris"
            enttreprise="&#64;Mon Chasseur Immo"
            image="https://ucarecdn.com/818cf540-3139-45bd-add5-6cf7ab5ceb9c/" />
          <BlocPreviewProfilExpert
            instance-class="element-3--p36"
            :options="{
              href: `https://www.matchers.fr/expert/158`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element3Click
            }"
            :xs="{ hidden: null }"
            :tags="page.$constants.element3Tags"
            poste="Directeur marketing et communication"
            first-name="Jean-Dominique"
            enttreprise="&#64;Trust Builder"
            image="https://ucarecdn.com/4eba8c52-eb5a-46d7-bf21-4fc36ef04418/" />
        </ka-container>
        <ka-text
          code="voir"
          :options="{
            href: `https://www.matchers.fr/experts`,
            ariaLabel: `voir`,
            click: page.voirClick
          }">
          <span v-html="t('prog03MarketingDigital.pageFormation.containerExperts.voir.value', `Voir plus de profils >`)" />
        </ka-text>
      </ka-container>
      <!-- Container programme -->
      <ka-container code="container-programme">
        <!-- Container gauche -->
        <ka-container code="container-gauche">
          <!-- Container programme de formation -->
          <ka-container code="container-programme-de-formation">
            <!-- Titre exemple de programme -->
            <ka-container code="titre-exemple-de-programme">
              <ka-text code="voici-un-exemple-de">
                <h2 v-html="t('prog03MarketingDigital.pageFormation.containerProgramme.containerGauche.containerProgrammeDeFormation.titreExempleDeProgramme.voiciUnExempleDe.value', `Voici un exemple de programme de formation`)" />
              </ka-text>
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="sections-deroulantes">
              <!-- Conteneur section -->
              <ka-container code="conteneur-section">
                <DropDownFormation
                  instance-class="drop-down-formation--p36"
                  titre="I.   Les fondamentaux de la communication et du marketing digital"
                  :arguments="page.$constants.dropDownFormationArguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-1">
                <DropDownFormation
                  instance-class="element-4--p36"
                  titre="II.   Le référencement naturel et/ou payant comme levier d’acquisition"
                  :arguments="page.$constants.element4Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-2">
                <DropDownFormation
                  instance-class="element-5--p36"
                  titre="III.   Les fondamentaux du marketing automation"
                  :arguments="page.$constants.element5Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-3">
                <DropDownFormation
                  instance-class="element-6--p36"
                  titre="IV.   Structurer ses campagnes de marketing automation"
                  :arguments="page.$constants.element6Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-4">
                <DropDownFormation
                  instance-class="element-7--p36"
                  titre="V.   Le tunnel de conversion"
                  :arguments="page.$constants.element7Arguments" />
              </ka-container>
            </ka-container>
          </ka-container>
          <CtaProgrammeSurMesurePrendreRdv instance-class="cta-programme-sur-mesure-prendre-rdv--p36" />
        </ka-container>
        <BlocArgCtaRdvPedagogieMatchers
          instance-class="bloc-arg-cta-rdv-pedagogie-matchers--p36"
          :xs="{ hidden: null }"
          expert-1="https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg" />
      </ka-container>
      <BlocArgPasDeFraisPasDeDemarchesAdministratives instance-class="bloc-arg-pas-de-frais-pas-de-demarches-admi--p36" />
      <PFormationMatching
        instance-class="p-formation-matching--p36"
        description-company="<strong>Accord</strong> <strong>Parfait</strong> | Boutique de costumes, robes &amp; vêtements de cérémonie.<br> <br> <br><strong>Besoin : </strong>Construire une stratégie marketing digital pour augmenter la notoriété de la marque en ligne."
        expert-text="<strong>Olivia </strong>| Responsable marketing digital et social media | &#64;Yves Rocher.<br> <br> <br><strong>Expertise : </strong>Plus de 10 ans d'expertise dans le digital."
        budget-available="6 000€"
        training-hours="60h"
        photo-expert="https://ucarecdn.com/55dbfe1e-0e16-4e4f-bad3-94df92eea150/"
        image="https://ucarecdn.com/dda83ec6-1b23-445f-a882-547ac982f8db/" />
      <BlocReassuranceQualiopi instance-class="bloc-reassurance-qualiopi--p36" />
      <PFormationCriteresQualiopi instance-class="p-formation-criteres-qualiopi--p36" />
      <PFormationPourquoiSeFormer
        instance-class="p-formation-pourquoi-se-former--p36"
        text="Pourquoi se former en marketing digital avec Matchers ?"
        text-1="Le marketing digital englobe toutes les stratégies développées pour <strong>acquérir de la notoriété</strong> sur Internet. Peu importe la taille ou les moyens de votre entreprise, vous pouvez toujours activer certains leviers ! Notre formation sur-mesure en marketing digital vous permet de choisir judicieusement lesquels, comment les mettre en place et comment les optimiser."
        image="https://ucarecdn.com/75ecfa10-1b8f-4924-ac92-cea7296bf29e/" />
    </ka-container>
    <!-- Sections du domaine -->
    <ka-container code="sections-du-domaine">
      <PFormationSectionBleu
        instance-class="p-formation-section-bleu--p36"
        paragraph="Également connue sous le nom de modèle AARRR ou entonnoir de conversion, il s’agit d’un outil marketing utilisé pour <strong>analyser et optimiser les différentes étapes du processus de croissance d'une entreprise</strong>. Chaque lettre de l'acronyme AARRR représente une étape clé du parcours client.<br> <br>Acquisition (Acquisition) 👉  Première étape du processus, elle consiste à <strong>attirer l'attention des utilisateurs potentiels</strong> et les inciter à visiter votre site web, télécharger votre application ou s'engager d'une autre manière.<br> <br>Activation (Activation) 👉  Après avoir attiré les utilisateurs, vous devez les <strong>convertir en utilisateurs actifs</strong> : création d'un compte, première action sur votre plateforme... Ils interagissent en démontrant leur intérêt et leur engagement.<br> <br>Référence (Retention) 👉 Lors de cette étape, vous travaillez à <strong>maintenir les utilisateurs actifs et à les fidéliser</strong>. Vous cherchez à les inciter à revenir régulièrement, à utiliser votre produit ou service de manière continue et à en tirer de la valeur.<br> <br>Recette (Revenue) 👉 Cette étape concerne la <strong>génération de revenus</strong> à partir de vos utilisateurs (business model).<br> <br>Recommandation (Referral) 👉 Enfin, la dernière étape consiste à <strong>encourager vos utilisateurs satisfaits à recommander</strong> votre produit ou service à d'autres personnes et faire d’eux des ambassadeurs."
        title="Un outil incontournable, la matrice AARRR"
        picture="https://ucarecdn.com/342e40be-53f7-44a9-b444-735374b680fd/" />
      <PFormationSectionBanche
        instance-class="p-formation-section-banche--p36"
        paragraph="Selon les canaux utilisés, le marketing digital peut tout autant vous permettre d’atteindre un <strong>public large et diversifié</strong>, qu’une <strong>cible restreinte et précise</strong>.<br> <br>En activant les bons leviers, le marketing digital peut vous permettre de promouvoir votre entreprise aux quatre coins du monde ou booster votre notoriété à l’échelle locale."
        title="Étendre sa notoriété, oui, mais jusqu’où ?"
        picture="https://ucarecdn.com/ab123a53-5514-4b84-b56a-b4bfb14e90ee/" />
      <PFormationSectionBleu
        instance-class="element-8--p36"
        paragraph="Les techniques et les outils pour agir sont très divers, il est donc très important de <strong>fixer des objectifs et de connaître votre cible</strong> avant de vous lancer. Si l’un de nos experts vous accompagne sur le marketing digital, il vous demandera à coup sûr “qui est votre persona ?”.<br> <br>En plus de se baser sur ce que vous vendez et à qui, le marketing digital est guidé par vos <strong>objectifs commerciaux</strong> : quel est votre canal de conversion principal, votre boutique en ligne ? Votre point de vente ? Vos échanges téléphoniques ?<br> <br>Si tous ces points ne sont pas encore clairs pour vous, notre expert pourra vous aider à les déterminer pour orienter votre stratégie en marketing digital."
        title="Réfléchir avant d’agir"
        picture="https://ucarecdn.com/d5957739-c878-4096-96f5-f55772965678/" />
      <PFormationSectionBanche
        instance-class="element-9--p36"
        paragraph="Quels que soient vos objectifs ou la taille de votre entreprise, le marketing digital regroupe forcément des <strong>leviers</strong> que votre entreprise peut exploiter (réseaux sociaux, relations presse, webinar, campagnes sponsorisées, partenariat d’influence…).  <br> <br>Certains sont même <strong>gratuits</strong> ! En effet, le référencement naturel ou les réseaux sociaux sont deux moyens qui peuvent être exploités sans aucun coût, si ce n’est votre temps.<br> <br>Cependant, il est important de déterminer <strong>le levier le plus rentable en fonction de vos objectifs</strong> pour ne pas consacrer du temps à des actions qui ne visent que 10% de vos prospects.  "
        title="Le marketing digital, un large choix de leviers"
        picture="https://ucarecdn.com/f6732c42-85e8-4845-af6b-f179bd004619/" />
      <PFormationSectionBleu
        instance-class="element-10--p36"
        paragraph="Vous préparez trois posts Linkedin par semaine mais vous n’avez que 10 likes ?<br> <br>Vous avez beaucoup de trafic sur votre site mais un taux de conversion beaucoup trop faible ?<br> <br>Personne n’ouvre votre newsletter ?  <br> <br><strong>Les résultats ne sont pas bons, mais tous ces problèmes sont positifs !</strong><br> <br>Vous avez commencé à <strong>investir du temps</strong> sur vos leviers digitaux et vous avez déjà des indicateurs clés de performance à évaluer. Au cours d’une formation, notre expert s’appuie sur VOS chiffres. Vous pouvez donc évaluer ces chiffres ensemble, et comprendre quelle étape nécessite des changements et des améliorations.  <br> <br>Cette formation <strong>clarifiera votre vision des canaux</strong> sur lesquels vous devez être présent d’après l’activité de votre entreprise et le type de contenu à produire."
        title="Optimisez ce que vous faites déjà"
        picture="https://ucarecdn.com/c4ff7fc8-47af-4439-92e0-da3743d3c721/" />
      <PFormationSectionBanche
        instance-class="element-11--p36"
        paragraph="Vous trouvez le format newsletter intéressant et vous souhaitez rapidement connaître un outil pour mettre en place ce support.<br> <br>Problème : Vous n’avez qu’un très maigre fichier de contacts, et ce serait dommage de consacrer du temps à un mail qui ne sera pas lu par plus de 30 personnes.<br> <br>L’un des objectifs de votre stratégie en marketing digital peut donc concerner la constitution d’un fichier de prospects pour mettre en place, par la suite, une stratégie d’emailing.<br> <br>Peu importe la taille de votre entreprise et ses objectifs, établir et mettre en place une stratégie de marketing digital <strong>étape par étape</strong> assure son bon déroulement et son fonctionnement !"
        title="Tout n’est pas réalisable tout de suite"
        picture="https://ucarecdn.com/58d4b84b-2664-4969-917c-b5fd83b863cf/" />
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { formationsMarketingDigital } from './store'
import BlocArgCtaRdvPedagogieMatchers from '~/components/BlocArgCtaRdvPedagogieMatchers/index.vue'
import BlocArgPasDeFraisPasDeDemarchesAdministratives from '~/components/BlocArgPasDeFrais/PasDeDemarchesAdministratives/index.vue'
import BlocPreviewProfilExpert from '~/components/BlocPreviewProfilExpert/index.vue'
import BlocReassuranceQualiopi from '~/components/BlocReassuranceQualiopi/index.vue'
import CtaProgrammeSurMesurePrendreRdv from '~/components/CtaProgrammeSurMesurePrendreRdv/index.vue'
import DropDownFormation from '~/components/DropDownFormation/index.vue'
import PFormationCriteresQualiopi from '~/components/PFormationCriteresQualiopi/index.vue'
import PFormationEntete from '~/components/PFormationEntete/index.vue'
import PFormationMatching from '~/components/PFormationMatching/index.vue'
import PFormationPourquoiSeFormer from '~/components/PFormationPourquoiSeFormer/index.vue'
import PFormationSectionBanche from '~/components/PFormationSectionBanche/index.vue'
import PFormationSectionBleu from '~/components/PFormationSectionBleu/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p36')
const appData = appDataStore()
const page = formationsMarketingDigital()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
